"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNumber = _interopRequireDefault(require("./isNumber"));

var _isNumeric = _interopRequireDefault(require("./isNumeric"));

var getValidatedNumber = function getValidatedNumber(input, defaultValue) {
  if (!(0, _isNumber["default"])(defaultValue)) {
    throw new Error('Cannot set default that is not a number');
  }

  if (!(0, _isNumeric["default"])(input)) {
    return defaultValue;
  } else if (!(0, _isNumber["default"])(input)) {
    var parsedInput = parseFloat(input);

    if (!(0, _isNumber["default"])(parsedInput)) {
      return defaultValue;
    } else {
      return parsedInput;
    }
  }

  return input;
};

var _default = getValidatedNumber;
exports["default"] = _default;